import { render, staticRenderFns } from "./socialButtons.vue?vue&type=template&id=6f89f3c2&scoped=true&"
import script from "./socialButtons.vue?vue&type=script&lang=js&"
export * from "./socialButtons.vue?vue&type=script&lang=js&"
import style0 from "./socialButtons.vue?vue&type=style&index=0&id=6f89f3c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f89f3c2",
  null
  
)

export default component.exports